import { Divider, Menu } from "antd";
import logo_Dolrr from "../../assets/logo_descope.jpg";
import { useNavigate } from "react-router-dom";
import "./sidebar.scss";
import { MdBarChart, MdHome } from "react-icons/md";
import { useUser, useSession } from "@descope/react-sdk";

const getItem = (label, key, icon) => {
  return {
    key,
    icon,
    label,
  };
};

const items = [
  getItem("New Companies", "/", <MdHome style={{ fontSize: "1.2em" }} />),
  getItem("Top Companies", "/top", <MdBarChart style={{ fontSize: "1.5em" }} />),
  getItem("Startup Companies", "/startup", <MdBarChart style={{ fontSize: "1.5em" }} />),
  getItem("Free Companies", "/free", <MdBarChart style={{ fontSize: "1.5em" }} />),
  getItem("In Production", "/prod", <MdBarChart style={{ fontSize: "1.5em" }} />),
];

const Sidebar = () => {
  const navigate = useNavigate();

  const { isUserLoading } = useUser();
  const { isSessionLoading } = useSession();

  if (isUserLoading || isSessionLoading) {
    return null;
  }

  return (
    <section className="sidebar-container">
      <div className="logo-container">
        <img src={logo_Dolrr} alt="dolrr-logo" className="img-logo" />
      </div>
      <Divider className="divider" />
      <Menu
        onClick={({ key }) => {
          navigate(key, { state: items.find((elm) => elm.key === key).label });
        }}
        items={items.map((item) => {
          return item;
        })}
        selectedKeys={[window.location.pathname]}
      />
    </section>
  );
};

export default Sidebar;